import { render, staticRenderFns } from "./UserSignUp.vue?vue&type=template&id=55413446&scoped=true"
import script from "./UserSignUp.vue?vue&type=script&lang=js"
export * from "./UserSignUp.vue?vue&type=script&lang=js"
import style0 from "./UserSignUp.vue?vue&type=style&index=0&id=55413446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55413446",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VForm,VProgressCircular})
